import { CuentaAdministrativa } from '../../types/identidad';
import { Badge } from '../shared/Badge';
import { TrashIcon } from '../shared/icons';

interface Props {
  cuentas: CuentaAdministrativa[];
  onCambiarRol: (id: string, rol: CuentaAdministrativa['rol']) => void;
  onEliminar: (id: string) => void;
}

/** FR-ID-02 (espejo de BR-ID-02): deshabilita eliminar/degradar la unica cuenta Administrador activa visible. */
export function AccountTable({ cuentas, onCambiarRol, onEliminar }: Props) {
  const administradoresActivos = cuentas.filter((c) => c.rol === 'Administrador' && c.activo).length;

  return (
    <div className="bg-white border border-admin-border rounded-xl overflow-x-auto">
      <table className="w-full min-w-[560px] border-collapse text-[13px]">
        <thead>
          <tr>
            {['Nombre', 'Usuario', 'Rol', 'Creada', ''].map((h) => (
              <th
                key={h}
                className="text-left text-[11px] font-bold uppercase tracking-wide text-admin-ink-muted px-4 py-2.5 border-b border-admin-border"
              >
                {h}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {cuentas.map((cuenta) => {
            const esUltimoAdmin = cuenta.rol === 'Administrador' && administradoresActivos <= 1;
            return (
              <tr key={cuenta.id} data-testid={`account-table-row-${cuenta.id}`} className="border-b border-admin-border/60 last:border-0">
                <td className="px-4 py-3.5 font-semibold">
                  {cuenta.nombre} {cuenta.apellido}
                </td>
                <td className="px-4 py-3.5 text-admin-ink-muted">{cuenta.usuario}</td>
                <td className="px-4 py-3.5">
                  <select
                    value={cuenta.rol}
                    disabled={esUltimoAdmin}
                    onChange={(e) => onCambiarRol(cuenta.id, e.target.value as CuentaAdministrativa['rol'])}
                    className="border border-admin-border rounded-md px-2.5 py-1.5 text-xs disabled:opacity-50"
                  >
                    <option value="Administrador">Administrador</option>
                    <option value="Empleado">Empleado</option>
                  </select>
                </td>
                <td className="px-4 py-3.5 text-admin-ink-muted">
                  {new Date(cuenta.fechaCreacion).toLocaleDateString('es-PE')}
                </td>
                <td className="px-4 py-3.5 text-right">
                  {esUltimoAdmin ? (
                    <span title="No se puede eliminar la única cuenta Administrador activa">
                      <Badge color="neutro">Protegida</Badge>
                    </span>
                  ) : (
                    <button
                      onClick={() => onEliminar(cuenta.id)}
                      data-testid={`account-delete-button-${cuenta.id}`}
                      aria-label={`Eliminar cuenta ${cuenta.usuario}`}
                      className="text-danger"
                    >
                      <TrashIcon width={15} height={15} />
                    </button>
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
